import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import response from './response';

const isdemo = false;

const actions = {
  async dashboardConfig({ commit }, params) {
    try {
      const result = await axios(`/dashboard/config/${params.name}`);
      if (result && result.data) {
        commit('setDashboardConfig', result.data.config);
        commit('setDashboardParams', [result.data.params]);
        commit('setCategory', params.name);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async quickSightDashboardConfig({ commit }, params) {
    try {
      const result = await axios(`/quicksight-dashboard/config/${params.name}`);
      if (result && result.data) {
        commit('setQuickSightDashboardConfig', result.data);
        commit('setCategory', params.name);
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async count({ commit }, params) {
    try {
      commit('COUNT_LOADING', true);
      let result = await axios.get('/dashboard/order/count', { params });
      if (isdemo) {
        result = response.count;
      }
      if (result && result.data) {
        commit('COUNT_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('COUNT_LOADING', false);
    }
  },
  async transporter({ commit }, params) {
    try {
      commit('TRANSPORTER_LOADING', true);
      let result = await axios.get('/dashboard/transporter', { params });
      if (isdemo) {
        result = response.transporter;
      }
      if (result && result.data) {
        commit('TRANSPORTER_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('TRANSPORTER_LOADING', false);
    }
  },
  async transporterlist({ commit }) {
    try {
      commit('TRANSPORTER_LIST_LOADING', true);
      const result = await axios.get('/dashboard/transporter/list');
      if (result && result.data) {
        commit('TRANSPORTER_LIST_DATA', result.data);
        commit('setDashboardConfig', null);
        commit('setCategory', null);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('TRANSPORTER_LIST_LOADING', false);
    }
  },
  async sla({ commit }, params) {
    try {
      commit('SLA_LOADING', true);
      let result = await axios.get('/dashboard/order/sla', { params });
      if (isdemo) {
        result = response.sla;
      }
      if (result && result.data) {
        commit('SLA_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SLA_LOADING', false);
    }
  },
  async vehicletype({ commit }, params) {
    try {
      commit('VEHICLETYPELOADING_LOADING', true);
      let result = await axios.get('/dashboard/vehicle_type', { params });
      if (isdemo) {
        result = response.vehicletype;
      }
      if (result && result.data) {
        commit('VEHICLETYPELOADING_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('VEHICLETYPELOADING_LOADING', false);
    }
  },
  async vehicletypeutilized({ commit }, params) {
    try {
      commit('VEHICLETYPEUTILIZEDLOADING_LOADING', true);
      let result = await axios.get('/dashboard/vehicle_type/utilization', { params });
      if (isdemo) {
        result = response.vehicletype;
      }
      if (result && result.data) {
        commit('VEHICLETYPEUTILIZED_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('VEHICLETYPEUTILIZEDLOADING_LOADING', false);
    }
  },
  async kpi({ commit }, params) {
    try {
      commit('KPI_LOADING', true);
      const result = await axios.get('/dashboard/kpi', { params });
      if (result && result.data) {
        commit('KPI_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('KPI_LOADING', false);
    }
  },
  async gatesla(_, params) {
    try {
      const result = await axios.get('/dashboard/gate_sla', { params });
      return result.data;
    } catch (err) {
      return err;
    }
  },
};

export default actions;
